import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

export const fetchFixedExpenses = createAsyncThunk('fixedExpenses/fetchAll', async (_, { rejectWithValue }) => {
  try {
    const response = await api.get('/fixed-expenses');
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.error || 'Error al obtener gastos fijos');
  }
});

export const createFixedExpense = createAsyncThunk('fixedExpenses/create', async (data, { rejectWithValue }) => {
  try {
    const response = await api.post('/fixed-expenses', data);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.error || 'Error al crear gasto fijo');
  }
});

export const updateFixedExpense = createAsyncThunk('fixedExpenses/update', async ({ id, data }, { rejectWithValue }) => {
  try {
    const response = await api.put(`/fixed-expenses/${id}`, data);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.error || 'Error al actualizar gasto fijo');
  }
});

export const deleteFixedExpense = createAsyncThunk('fixedExpenses/delete', async (id, { rejectWithValue }) => {
  try {
    await api.delete(`/fixed-expenses/${id}`);
    return id;
  } catch (error) {
    return rejectWithValue(error.response?.data?.error || 'Error al eliminar gasto fijo');
  }
});

export const fetchFixedExpensePayments = createAsyncThunk('fixedExpenses/fetchPayments', async (id, { rejectWithValue }) => {
  try {
    const response = await api.get(`/fixed-expenses/${id}/payments`);
    return { id, payments: response.data };
  } catch (error) {
    return rejectWithValue(error.response?.data?.error || 'Error al obtener historial');
  }
});

export const payFixedExpense = createAsyncThunk('fixedExpenses/pay', async ({ id, data }, { rejectWithValue }) => {
  try {
    const response = await api.post(`/fixed-expenses/${id}/pay`, data);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.error || 'Error al registrar pago');
  }
});

const fixedExpensesSlice = createSlice({
  name: 'fixedExpenses',
  initialState: {
    fixedExpenses: [],
    paymentsHistory: {},   // { [fixedExpenseId]: [...payments] }
    lastCreatedExpense: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => { state.error = null; },
    clearLastExpense: (state) => { state.lastCreatedExpense = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFixedExpenses.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFixedExpenses.fulfilled, (state, action) => {
        state.loading = false;
        state.fixedExpenses = action.payload;
      })
      .addCase(fetchFixedExpenses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchFixedExpensePayments.fulfilled, (state, action) => {
        state.paymentsHistory[action.payload.id] = action.payload.payments;
      })
      .addCase(payFixedExpense.fulfilled, (state, action) => {
        state.lastCreatedExpense = action.payload.expense_created;
      });
  },
});

export const { clearError, clearLastExpense } = fixedExpensesSlice.actions;
export default fixedExpensesSlice.reducer;
